import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const categories = [
    {
      id: 1,
      name: "pittleforestandco Notebooks",
      image: "/generated/editorial/1.png",
    },
    {
      id: 2,
      name: "pittleforestandco Pens",
      image: "/generated/editorial/2.png",
    },
    {
      id: 3,
      name: "pittleforestandco Notebook Bands",
      image: "/generated/editorial/3.png",
    },
    {
      id: 4,
      name: "pittleforestandco Gift Sets",
      image: "/generated/editorial/4.png",
    },
  ];

  const journalPosts = [
    {
      id: 1,
      title: "Father's Day Gifts 2026",
      description: "Gifts that are made to be enjoyed every day.",
      image: "/generated/editorial/5.png",
    },
    {
      id: 2,
      title: "Pocket Stationery Moment",
      description: "Small but powerful creative tools.",
      image: "/generated/editorial/6.png",
    },
    {
      id: 3,
      title: "pittleforestandco Spring Picks",
      description: "Refresh your workspace this Spring.",
      image: "/generated/editorial/7.png",
    },
    {
      id: 4,
      title: "How to Make Your Notebook Last Longer",
      description: "Simple habits that protect them day-to-day.",
      image: "/generated/editorial/8.png",
    },
  ];

  return (
    <div className="main">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-image">
          <img src="/generated/editorial/home-hero.png" alt="Discover the Pocket Pen" />
        </div>
        <div className="hero-content1">
          <h2>Discover the Pocket Pen.</h2>
          <p>
            Small enough to carry everywhere, satisfying to use when you need
            it.
          </p>
          <p className="hero-sub">Small, polished, ready to write.</p>
        </div>
      </section>

      {/* New Arrivals */}
      <section className="new-arrivals">
        <div className="container">
          <h2>New Arrivals</h2>
          <div className="products-grid">
            {productData.slice(0, 4).map((product) => (
              <div key={product.id} className="product-card">
                <div className="product-image-wrapper">
                  <img src={product.homeImage || product.image} alt={product.name} />
                  <span className="product-badge">{product.badge}</span>
                </div>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">${product.price}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Feature Banner */}
      <section className="feature-banner">
        <div className="banner-top">
          <p className="quote">
            "Thoughtful stationery for ideas that deserve a place to grow"
          </p>
          <p className="quote-source">- pittleforestandco</p>
        </div>
        <div className="banner-content">
          <div className="banner-image">
            <img src="/generated/editorial/home-planners.png" alt="pittleforestandco Academic Planners" />
          </div>
          <div className="banner-text">
            <h3>New In: pittleforestandco Academic Planners</h3>
            <p>
              Our mid-year journals have arrived, and they're bound in
              water-resistant linen bookcloth with brass wire-o binding.
            </p>
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="categories">
        <div className="container">
          <div className="categories-grid">
            {categories.map((category) => (
              <div key={category.id} className="category-card">
                <img src={category.image} alt={category.name} />
                <h3>{category.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial */}
      <section className="testimonial">
        <div className="container">
          <div className="stars">★★★★★</div>
          <p className="testimonial-text">
            "you cannot beat the quality 100gsm paper, textured cover (love the
            forest green I went for this time) and personalisation you receive
            when you get your order."
          </p>
        </div>
      </section>

      {/* Journal */}
      <section className="journal">
        <div className="container">
          <h2>The pittleforestandco Journal</h2>
          <div className="journal-grid">
            {journalPosts.map((post) => (
              <div key={post.id} className="journal-card">
                <img src={post.image} alt={post.title} />
                <h3>{post.title}</h3>
                <p>{post.description}</p>
                <Link to="/" onClick={toTop} className="read-more">
                  Read more →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Main;
